import { createClient } from "@supabase/supabase-js";
import {
  reportsSupabaseUrl,
  reportsSupabaseAPIKey,
  broccoliHarvestOptimiserSupabaseAPIKey,
  broccoliHarvestOptimiserSupabaseURL,
  supabaseAPIKey,
  supabaseURL,
} from "./config.js";

let broccoliHarvestOptimiserSupabaseClient;
let reportsSupabaseClient;

export const supabase = createClient(supabaseURL, supabaseAPIKey, {
  auth: { persistSession: true, autoRefreshToken: true },
});

export function getBroccoliHarvestOptimiserSupabase() {
  if (!broccoliHarvestOptimiserSupabaseURL || !broccoliHarvestOptimiserSupabaseAPIKey) {
    throw new Error("Broccoli harvest optimiser Supabase config is missing.");
  }

  if (!broccoliHarvestOptimiserSupabaseClient) {
    broccoliHarvestOptimiserSupabaseClient = createClient(
      broccoliHarvestOptimiserSupabaseURL,
      broccoliHarvestOptimiserSupabaseAPIKey,
      { auth: { persistSession: true, autoRefreshToken: true } },
    );
  }

  return broccoliHarvestOptimiserSupabaseClient;
}

export function getReportsSupabase() {
  if (!reportsSupabaseUrl || !reportsSupabaseAPIKey) {
    throw new Error("Reports Supabase config is missing.");
  }

  if (!reportsSupabaseClient) {
    reportsSupabaseClient = createClient(reportsSupabaseUrl, reportsSupabaseAPIKey, {
      auth: { persistSession: true, autoRefreshToken: true },
    });
  }

  return reportsSupabaseClient;
}

export async function checkOrgHasReports(orgId) {
  try {
    const supabase = getReportsSupabase();
    const { count, error } = await supabase
      .from("reports")
      .select("id", { count: "exact", head: true })
      .eq("org_id", orgId);
    if (error) return false;
    return (count ?? 0) > 0;
  } catch {
    return false;
  }
}
